(function () {
  'use strict';

  const header = document.querySelector('.murmures-header');
  if (header) {
    window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 30), { passive: true });
  }

  const hamburger = document.querySelector('.murmures-hamburger');
  const mobileMenu = document.querySelector('.murmures-mobile-menu');
  const mobileOverlay = document.querySelector('.murmures-mobile-overlay');
  const mobileClose = document.querySelector('.murmures-mobile-close');

  function openMobileMenu() { mobileMenu && mobileMenu.classList.add('open'); mobileOverlay && mobileOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMobileMenu() { mobileMenu && mobileMenu.classList.remove('open'); mobileOverlay && mobileOverlay.classList.remove('open'); document.body.style.overflow = ''; }

  hamburger && hamburger.addEventListener('click', openMobileMenu);
  mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileMenu);
  mobileMenu && mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileMenu));

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); revealObserver.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('visible'));
  }

  function initCarousel(sel) {
    const container = document.querySelector(sel);
    if (!container) return;
    const slides = container.querySelectorAll('[class*="slide"]');
    if (slides.length < 2) return;
    let i = 0;
    slides[0].classList.add('active');
    setInterval(() => { slides[i].classList.remove('active'); i = (i + 1) % slides.length; slides[i].classList.add('active'); }, 3500);
  }
  initCarousel('.murmures-hero__visual');
  initCarousel('.murmures-about__visual');

  const mainImg = document.querySelector('.murmures-product__gallery-main img');
  const mainContainer = document.querySelector('.murmures-product__gallery-main');
  const thumbs = document.querySelectorAll('.murmures-product__thumb');
  const galleryImages = [];

  thumbs.forEach((thumb) => {
    const fullSrc = thumb.dataset.full || thumb.querySelector('img')?.src;
    const mediumSrc = thumb.dataset.medium || fullSrc;
    if (fullSrc) galleryImages.push(fullSrc);
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = mediumSrc;
      if (mainContainer) mainContainer.dataset.full = fullSrc;
    });
  });
  if (thumbs.length > 0) thumbs[0].classList.add('active');

  const lightbox = document.querySelector('.murmures-lightbox');
  const lbImg = lightbox?.querySelector('.murmures-lightbox__img');
  const lbCounter = lightbox?.querySelector('.murmures-lightbox__counter');
  let lbIndex = 0;
  const lbImages = galleryImages;

  function openLightbox(index) {
    if (!lightbox || lbImages.length === 0) return;
    lbIndex = index;
    lbImg.src = lbImages[lbIndex];
    if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbImages.length;
    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() { lightbox && lightbox.classList.remove('open'); document.body.style.overflow = ''; }
  function lbNav(dir) { lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length; lbImg.src = lbImages[lbIndex]; if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + lbImages.length; }

  document.querySelector('.murmures-product__gallery-main')?.addEventListener('click', () => {
    const activeIndex = Array.from(thumbs).findIndex(t => t.classList.contains('active'));
    openLightbox(activeIndex >= 0 ? activeIndex : 0);
  });
  lightbox?.querySelector('.murmures-lightbox__close')?.addEventListener('click', closeLightbox);
  lightbox?.querySelector('.murmures-lightbox__prev')?.addEventListener('click', (e) => { e.stopPropagation(); lbNav(-1); });
  lightbox?.querySelector('.murmures-lightbox__next')?.addEventListener('click', (e) => { e.stopPropagation(); lbNav(1); });
  lightbox?.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', (e) => {
    if (!lightbox?.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lbNav(-1);
    if (e.key === 'ArrowRight') lbNav(1);
  });

  function showToast(message) {
    let toast = document.querySelector('.murmures-toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'murmures-toast'; document.body.appendChild(toast); }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('show'), 2200);
  }

  function updateCartBadge() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('.cart-count-badge').forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        b.classList.add('bump');
        setTimeout(() => b.classList.remove('bump'), 400);
      });
    }).catch(() => {});
  }

  const atcBtn = document.querySelector('.murmures-product__atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      this.disabled = true;
      const originalLabel = this.textContent;
      this.textContent = 'Ajout en cours…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(r => r.json()).then(item => {
        showToast((item.product_title || 'Article') + ' ajouté au panier');
        updateCartBadge();
        this.disabled = false;
        this.textContent = originalLabel;
      }).catch(() => {
        showToast('Erreur — veuillez réessayer');
        this.disabled = false;
        this.textContent = originalLabel;
      });
    });
  }

  document.querySelectorAll('.murmures-qty-minus, .murmures-qty-plus').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      const delta = this.classList.contains('murmures-qty-plus') ? 1 : -1;
      const qtyEl = document.querySelector('[data-qty-key="' + key + '"]');
      const newQty = Math.max(0, parseInt(qtyEl?.textContent || '1') + delta);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: newQty }) })
        .then(() => location.reload()).catch(() => {});
    });
  });

  document.querySelectorAll('.murmures-cart-item__remove').forEach(btn => {
    btn.addEventListener('click', function () {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.dataset.key, quantity: 0 }) })
        .then(() => location.reload()).catch(() => {});
    });
  });

  updateCartBadge();

  /* ===== Sélecteur de langue ===== */
  const langContainer = document.querySelector('[data-lang-switcher]');
  if (langContainer) {
    const langToggle = langContainer.querySelector('.murmures-lang__toggle');
    const langMenu = langContainer.querySelector('.murmures-lang__menu');

    langToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = langContainer.hasAttribute('data-open');
      if (isOpen) {
        langContainer.removeAttribute('data-open');
        langMenu.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
      } else {
        langContainer.setAttribute('data-open', '');
        langMenu.hidden = false;
        langToggle.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', (e) => {
      if (!langContainer.contains(e.target)) {
        langContainer.removeAttribute('data-open');
        langMenu.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && langContainer.hasAttribute('data-open')) {
        langContainer.removeAttribute('data-open');
        langMenu.hidden = true;
        langToggle.setAttribute('aria-expanded', 'false');
        langToggle.focus();
      }
    });
  }
})();
